import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Select from 'react-select';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import * as actions from '../../../action';
import * as c from '../../../constant';
import AdditionalItemsModal from './AdditionalItemsModal';

function AdditionalItemsList({ value, onChange, setShowPaginateButton, getActualUseList,
  actualUseList, getBuildingComponents, componentList,
  floorArea, buvAmount, modalType, ordinanceRevisionId
}) {

  const [viewForm, setViewForm] = useState(false);
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');

  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    let result = value;
    result = result.map((n, i) => {
      return {
        ...n,
        id: i + 1,
      };
    });
    setItem({
      item: result || [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.length]);

  const updateProps = newItem => {
    onChange(_.get(newItem, 'item'));
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
    setShowPaginateButton(false);
  };

  const handleOnUpdateForm = data => e => {
    e.preventDefault();
    setViewUpdateForm(true, setFormData({ ...data }));
    setShowPaginateButton(true);
  };

  const closeModal = () => {
    setViewForm(false);
    setShowPaginateButton(false);
  };

  const handleAddModal = e => {
    e.preventDefault();
    setViewForm(true);
    setViewUpdateForm(false);
    setShowPaginateButton(true);
  };

  useEffect(() => {
    getActualUseList();
  }, []);

  useEffect(() => {
    getBuildingComponents();
  }, []);

  const handleRemove = (data) => () => {

    ConfirmAlert(
      'Are you sure you want to remove this additional item?',
      () => {
        const newItem = {
          item: (items.item || []).filter(x => x.id !== data.id)
        };
        setItem(newItem);
        updateProps(newItem);
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleValueFromChild = (data) => {
    const newItem = {
      item: (items.item || []).concat([
        {
          id: (_.get(items, `item.${items.item.length - 1}.id`) || 0) + 1,
          rptax_actual_use_id: _.get(data, 'rptax_actual_use_id'),
          rptax_building_component_id: _.get(data, 'rptax_building_component_id'),
          componentRate: _.get(data, 'componentRate'),
          type: _.get(data, 'type'),
          percent: _.get(data, 'percent'),
          floor: _.get(data, 'floor'),
          area: _.get(data, 'area'),
          rate: _.get(data, 'rate'),
          is_add_area: _.get(data, 'is_add_area'),
        },
      ]),
    };
    setItem(newItem);
    updateProps(newItem);
    setViewForm(false);
  };

  const handleOnUpdate = (updatedData) => {

    const finalItem = items.item.map(ele => {
      if (ele.id === updatedData.id) {
        return {
          ...ele,
          rptax_actual_use_id: _.get(updatedData, 'rptax_actual_use_id'),
          rptax_building_component_id: _.get(updatedData, 'rptax_building_component_id'),
          floor: _.get(updatedData, 'floor'),
          area: _.get(updatedData, 'area'),
          rate: _.get(updatedData, 'rate'),
          componentRate: _.get(updatedData, 'componentRate'),
          type: _.get(updatedData, 'type'),
          percent: _.get(updatedData, 'percent'),
          is_add_area: _.get(updatedData, 'is_add_area'),
        };
      }
      return ele;
    });

    const newItem = {
      item: finalItem,
    };
    setItem(newItem);
    updateProps(newItem);
    setFormData({});

    setViewUpdateForm(false);
  };

  const actualUseOptions = actualUseList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  const componentOptions = componentList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  return (
    <div className="col-12 mb-2">
      {viewUpdateForm === true || viewForm === true ? (
        ""
      ) : (
        <>
          <div className="row mb-3">
            <div className="col-8 mt-2 header-modal">
              Additional Items
            </div>
            {viewUpdateForm === true || viewForm === true ? (
              " "
            ) : (
              <div className="col-4 d-flex">
                <div className="ml-auto">
                  <button
                    type="button"
                    onClick={handleAddModal}
                    className="btn button-transaction font-weight-bold"
                  >
                    <i className="fas fa-plus" /> &nbsp; Add Additional Item
                  </button>
                </div>
              </div>
            )}
          </div>
          <table className="table-lease table table-borderless table-sm mt-4">
            <thead>
              <tr className="cms-bg-color-primary-light cms-text-primary">
                <th width="50">Floor</th>
                <th width="200">Actual Use</th>
                <th width="200">Component</th>
                <th width="100">Area</th>
                <th width="100">Rate</th>
                <th width="100" style={{ textAlign: 'center' }}>Add Area to Building Core</th>
                <th width="100">Action</th>
              </tr>
            </thead>
            <tbody>
              {(items.item || []).map((item, i) => (
                <tr key={`Item ${i + 1}`}>
                  <td width="50">
                    <input
                      type="text"
                      readOnly
                      className="custom-input my-2"
                      value={_.get(item, 'floor') || '-'}
                    />
                  </td>
                  <td width="200">
                    <Select
                      value={
                        actualUseOptions.find(
                          (x) => +x.value === +_.get(item, 'rptax_actual_use_id')
                        ) || ''
                      }
                      options={actualUseOptions}
                      placeholder="Select Actual Use"
                      className="react-select-container my-2"
                      classNamePrefix="react-select"
                      isDisabled
                    />
                  </td>
                  <td width="200">
                    <Select
                      value={
                        componentOptions.find(
                          (x) => +x.value === +_.get(item, 'rptax_building_component_id')
                        ) || ''
                      }
                      options={componentOptions}
                      placeholder="Select Building Component"
                      className="react-select-container my-2"
                      classNamePrefix="react-select"
                      isDisabled
                    />
                  </td>
                  <td width="50">
                    <input
                      type="text"
                      readOnly
                      className="custom-input my-2"
                      value={_.get(item, 'area') || '-'}
                    />
                  </td>
                  <td width="50">
                    <input
                      type="text"
                      readOnly
                      className="custom-input my-2"
                      value={_.get(item, 'rate') || 0}
                    />
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      readOnly
                      className='form-check-input mt-3'
                      type='checkbox'
                      checked={_.get(item, 'is_add_area') === 1}
                      name='is_add_area'
                      id='is_add_area'
                    />
                  </td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center align-items center my-2">
                      <button
                        onClick={handleOnUpdateForm(item, i)}
                        type="button"
                        className="btn-blank btn-sm"
                        disabled={viewUpdateForm === true}
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                      <button
                        type="button"
                        className="btn-blank btn-sm"
                        onClick={handleRemove(item)}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {viewForm === true && (
        <AdditionalItemsModal
          closeModal={closeModal}
          handleOnParent={handleValueFromChild}
          floorArea={floorArea}
          buvAmount={buvAmount}
          modalType={modalType}
          ordinanceRevisionId={+ordinanceRevisionId}
        />
      )}
      {viewUpdateForm === true && (
        <AdditionalItemsModal
          closeModal={closeUpdateModal}
          dataInfo={formData}
          handleOnParent={handleOnUpdate}
          floorArea={floorArea}
          buvAmount={buvAmount}
          modalType={modalType}
          ordinanceRevisionId={+ordinanceRevisionId}
        />
      )}
    </div>
  );
}

AdditionalItemsList.defaultProps = {
  setShowPaginateButton: () => { },
  floorArea: [],
  buvAmount: 0,
  modalType: '',
};

AdditionalItemsList.propTypes = {
  value: PropTypes.instanceOf(Array).isRequired,
  floorArea: PropTypes.instanceOf(Array),
  onChange: PropTypes.instanceOf(Function).isRequired,
  setShowPaginateButton: PropTypes.instanceOf(Function),
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  getBuildingComponents: PropTypes.instanceOf(Function).isRequired,
  componentList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  buvAmount: PropTypes.number,
  modalType: PropTypes.string
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
  componentList: _.get(api, `${c.GET_BUILDING_COMPONENTS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AdditionalItemsList);
